export const selectImageAsCoverDataSet = { cy: 'select-cover-photo-image' };
